
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/resources/hooks",
      function () {
        return require("private-next-pages/x/react-chat/resources/hooks.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/resources/hooks"])
      });
    }
  